/**
 * @typedef {Object} Category
 * @property {number} id
 * @property {string} name
 * @property {string|null} description
 * @property {string|null} imageUrl
 * @property {boolean} isActive
 * @property {number} displayOrder
 * @property {number} productCount
 */

/**
 * Normalize API category shape to a safe UI-friendly object.
 * @param {any} dto
 * @returns {Category}
 */
export function normalizeCategory(dto) {
  return {
    id: Number(dto?.id ?? 0),
    name: String(dto?.name ?? ""),
    description: dto?.description ?? null,
    imageUrl: dto?.imageUrl ?? null,
    isActive: Boolean(dto?.isActive),
    displayOrder: Number(dto?.displayOrder ?? 0),
    productCount: Number(dto?.productCount ?? 0),
  };
}
